<template>
    <BContainer class="container-pages" v-if="items.data != null">
      <BRow>
        <BCol xl="9">
          <BRow>
           <BCol xl="4" lg="4" class="d-xl-block d-lg-block d-md-none d-sm-none d-none">
            <div class="p-element-page shadow bg-white rounded">
              <FilterCategory :categories="items?.data?.categories"></FilterCategory>
            </div>
           </BCol>
           <BCol xl="8" lg="8">
            <div class="p-element-page shadow bg-white rounded">
                 <h1 class="h1-title" v-if="customerName">
                  {{ customerName }}
                 </h1>
                 <hr>
            </div>
            <div>
              <DisplayPublicPage :items="items.data.items.data"></DisplayPublicPage>
            </div>

             <PaginationItems class="mt-3"
          :last_page="lastPage">
        </PaginationItems>
            <div class="a-container mt-3 mb-3" v-if="$screen.isProduction">
                  <AdsCustomerBottom></AdsCustomerBottom>
            </div>
           </BCol>
         </BRow>

        </BCol>
        <BCol xl="3">
          <div class="a-container mt-3 mb-3" v-if="$screen.showDesktopAds">
            <AdsCustomerTopRight></AdsCustomerTopRight>
          </div>
           <TopPriceBlock :xl="12" :lg="12" :counter="3"></TopPriceBlock>
        </BCol>
      </BRow>
    </BContainer>
</template>

<script setup  >

const route = useRoute();

import { BContainer, BRow, BCol } from 'bootstrap-vue-next';
import { usePaginationStore } from '~/stores/pagination'
import DisplayPublicPage from '~/components/cmsCustomer/advertisement/display/DisplayPublicPage'
import FilterCategory from '~/components/cmsCustomer/advertisement/filter/FilterCategory.vue';
import TopPriceBlock from '~/components/widgets/Stips/TopPriceBlock.vue';
import AdsCustomerTopRight from '~/components/GoogleAdvertisements/AdsCustomerTopRight.vue';
import AdsCustomerBottom from '~/components/GoogleAdvertisements/AdsCustomerBottom.vue';
import { useCustomerLoginStore } from '~/stores/login/customer'
import { useCustomerItemsStore } from '~/stores/customer/items'
import PaginationItems from '~/components/cmsCustomer/advertisement/display/PaginationItems.vue';
import FilterDataByRoute from '~/components/cmsCustomer/advertisement/utils/FilterDataByRoute'
import { useShareMetaStore } from "~/stores/shareMeta";
const shareMeta = useShareMetaStore();
const config = useRuntimeConfig()
const { $srbTolat } = useNuxtApp()
const customerStore = useCustomerLoginStore()
const paginationStore = usePaginationStore()
const itemsStore = useCustomerItemsStore()
 
const { getPage } = FilterDataByRoute()

const idSlug = computed(() => route.params.id)
const page = computed(() => getPage())
const customerId = computed(() => 
  customerStore.loggedIn ? customerStore.customer.id : 0
) 
// povuci podatke
const { data: items, error, pending } = await useAsyncData(
  () => `ad-single-${route.fullPath}`,
  () =>
    itemsStore.getItemsCategoriesPaginatePublic({
      category: null,
      subcategory: null,
      fixed: null,
      type_ads: null,
      type_currency: null,
      place: null,
      page: page.value,
      id: customerId.value,
      customer_id : idSlug.value
    }),
  {
    // refetch kad se promeni kategorija (po potrebi dodaj još filtera)
    watch: [() => route.fullPath]
  }
)

const customerName = computed(() =>
  items?.value?.data?.items?.data?.[0]?.customer_name ?? null
)

const lastPage = computed(() =>
  items?.value?.data?.items?.last_page ?? 10
)



const canonicalUrl = computed(() => `https://pijace.com${route.fullPath}`)

const headTitle = computed(() => customerName.value ? `${customerName.value} | Oglasi` : 'Oglasi')

const headDescription = 'Oglasi stoka, voće, povrće, med, pčelarstvo, stočna hrana.'

// JSON-LD: CollectionPage + ItemList sa oglasima prodavca
const collectionLd = computed(() => {
  const list = items?.value?.data?.items?.data || []
  if (!customerName.value || list.length === 0) return null

  const itemListElement = list.map((ad, i) => ({
    '@type': 'ListItem',
    position: i + 1,
    item: {
      '@type': 'Thing',
      name: ad?.title || `Oglas ${i + 1}`,
      ...(ad?.id ? { url: `https://pijace.com/oglas/${ad.slug || $srbTolat.srbTolatPath(String(ad.title || ''))}/${ad.id}` } : {})
    }
  }))

  return {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    '@id': `${canonicalUrl.value}#collection`,
    url: canonicalUrl.value,
    name: headTitle.value,
    description: headDescription,
    inLanguage: 'sr',
    isPartOf: {
      '@type': 'WebSite',
      name: 'Pijace.com',
      url: 'https://pijace.com'
    },
    publisher: {
      '@type': 'Organization',
      name: 'Pijace.com',
      url: 'https://pijace.com',
      logo: {
        '@type': 'ImageObject',
        url: 'https://pijace.com/images/pijace-60.png'
      }
    },
    ...(itemListElement.length > 0
      ? {
          mainEntity: {
            '@type': 'ItemList',
            name: `Oglasi - ${customerName.value}`,
            numberOfItems: itemListElement.length,
            itemListElement
          }
        }
      : {})
  }
})

// JSON-LD: BreadcrumbList — Oglasi → prodavac
const breadcrumbLd = computed(() => {
  if (!customerName.value) return null

  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'Oglasi',
        item: 'https://pijace.com/oglasi/svi-oglasi/1'
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: customerName.value,
        item: canonicalUrl.value
      }
    ]
  }
})

watchEffect(() => {
  if (!customerName.value) return
  shareMeta.setMeta({
    title: headTitle.value,
    description: headDescription,
    url: canonicalUrl.value,
  })
})

usePijaceSeo({
  title: headTitle,
  description: headDescription,
  url: canonicalUrl,
  type: 'website',
  jsonLd: () => [collectionLd.value, breadcrumbLd.value],
})
</script>

<style>

</style>